import axios from 'axios';

const API = '/machinesim/api';

/**
 * Map stream field keys to existing simulator REST endpoints.
 * Unsupported keys return { supported: false } — UI should treat as read-only.
 */
export function encodeMachinePath(machineName, suffix) {
  return `${API}/${encodeURIComponent(machineName)}${suffix}`;
}

export async function writeFieldValue(machineName, fieldKey, value, extra = {}) {
  const path = (suffix, body) =>
    axios.post(encodeMachinePath(machineName, suffix), body);

  switch (fieldKey) {
    case 'execution':
      return path('/set-execution', { state: value });
    case 'part_count':
      return path('/part-count', { partCount: Number(value) });
    case 'feedrate':
      return path('/set-feedrate', { feedrate: Number(value) });
    case 'override':
      return path('/set-override', { override: Number(value) });
    case 'program':
      return path('/set-program', { program: value });
    case 'program_header':
      return path('/set-program-header', { header: value });
    case 'blockDelete':
      return path('/set-block-delete', { blockDelete: !!value });
    case 'cycleMode':
      return path('/set-cycle-mode', { cycleMode: value });
    default:
      break;
  }

  const m = /^TLM_T(\d+)_PRESET$/i.exec(fieldKey);
  if (m) {
    return path('/set-tool-preset', {
      toolNumber: Number.parseInt(m[1], 10),
      presetValue: Number(value),
    });
  }

  return null;
}

export function resetToolLife(machineName, toolsToReset) {
  return axios.post(encodeMachinePath(machineName, '/reset-tool-life'), {
    toolsToReset,
  });
}

